import { z } from 'zod';

// TODO remove these optional when we'll have all the icons

export const iconSchema = z
  .object({
    name: z.string().optional(),
    caption: z.string().nullable().optional(),
    url: z.string().optional(),
    previewUrl: z.string().nullable().optional(),
  })
  .nullable();

export type IconSchema = z.infer<typeof iconSchema>;
